import { AppEnvironment, merge } from 'src/environments/environment.common';

export const production = true;

export const environment: AppEnvironment = merge({
  production: true,
  hosts: {
    egresso: {
      host: 'talentos-backend.cloud.capes.gov.br',
      protocol: 'https',
    }
  }
});
